$(function () {
  /* logic to handle closing of the cookiebot banner unless the 'change concent' anchor is clicked */

  var display_val = "none";

  if ($(".page-cookie").length > 0) {
    display_val = "block";
  }

  // window.addEventListener(
  //   "CookiebotOnDialogInit",
  //   function (e) {
  //     setTimeout(function () {
  //       $("#CybotCookiebotDialog").css("display", display_val);
  //     }, 100);
  //   },
  //   false
  // );

  $(document).on(
    "click",
    "#CookieDeclarationChangeConsent a, .j-cookie-pref-settings",
    function (e) {
      e.preventDefault();

      CookieConsent.renew();
      CookieDeclaration.SetUserStatusLabel();

      setTimeout(function () {
        $("#CybotCookiebotDialog").css("display", display_val);
      }, 50);
    }
  );

  // $(document).on('click','#CybotCookiebotDialogBodyButtonAccept, CybotCookiebotDialogBodyButtonDecline' function(e) {
  // 	setTimeout(function(){
  // 		// $('#CybotCookiebotDialog').css('display',display_val);
  // 		$('#CybotCookiebotDialog').removeClass('active');
  // 	}, 100);
  // });

  /* end */

  

  /* password validation */

  function validateField(input, msg, status) {
    if (input.find("p.status-msg").length > 0) {
      input.find("p.status-msg").text(msg);
    } else {
      input.append('<p class="status-msg ' + status + '">' + msg + "</p>");
    }
  }

  if ($("#CreatePassword").length > 0) {
    var msg = "Minimum of 8 characters and have at least 1 letter and number"; // gemeral msg

    var inputWrap = $("#CreatePassword").closest(".input-wrap");

    var c1 = { status: false, msg: "Password must be at least 8 characters" }; // min 8 characters
    var c2 = { status: false, msg: "Password must contain at least 1 letter" }; // contain a letter
    var c3 = { status: false, msg: "Password must contain at least 1 number" }; // contain a number

    $(document).on("input", "#CreatePassword", function (e) {
      var userVal = $(this).val();

      if (userVal.length >= 8) {
        c1.status = true;
      } else {
        c1.status = false;
      }

      var letters = /[a-zA-Z]/g;
      if (userVal.match(letters)) {
        c2.status = true;
      } else {
        c2.status = false;
      }

      var numbers = /[0-9]/g;
      if (userVal.match(numbers)) {
        c3.status = true;
      } else {
        c3.status = false;
      }
    });

    $("#create_customer").submit(function (event) {
      if (c1.status == false || c2.status == false || c3.status == false) {
        event.preventDefault();
        validateField(inputWrap, msg, "error");
      } else {
        inputWrap.find("p.status-msg").remove();
      }
    });
  }

  /* end */

  var header = $(".site-header");

  function body_lock_toggle() {
    $("body").toggleClass("lock");
  }

  $.fn.extend({
    toggleText: function (a, b) {
      return this.text(this.text() == b ? a : b);
    },
  });

  $(window).scroll(function () {
    if ($(document).scrollTop() > 1) {
      header.addClass("active");
    } else {
      header.removeClass("active");
    }
  });

  if ($(".j-home-hero .home-hero").length > 1) {

    $(".j-home-hero").on('afterChange init', function(event, slick){
      slickVideoAutoplayHandler(slick);
    });

    $(".j-home-hero").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      dots: true,
      autoplaySpeed: 5000,
      speed: 1000,
    });

  }

  if ($(window).width() < 622) {
    $(document).on("click", ".j-toggle-menu", function (e) {
      e.preventDefault();
      console.log("clicked 2");
      $(this).toggleClass("active");
      body_lock_toggle();

      header.addClass("menu-active active");
      $(".j-show-shopnav").trigger("click");

      if (!$(this).hasClass("active")) {
        header.removeClass("menu-active active");
      }
      // header.toggleClass('menu-active active');
      // body_lock_toggle();
      //$('.j-show-shopnav').trigger('click');
    });
  }

  // On click outisde of open menu

  $(document).mouseup(function (e) {
    var openMenu = $(".site-header.menu-active .menu-wrapper, .j-toggle-menu");

    // if the target of the click isn't the container nor a descendant of the container
    if (!openMenu.is(e.target) && openMenu.has(e.target).length === 0) {
      $(".site-header").removeClass("menu-active");
      $(".dt-menu li a").removeClass("active");
    }
  });

  // Set cookie for cookie policy modal

  // var cookie_box = Cookies.get("cookie_box");
  var newletter_box = Cookies.get("newletter_box");

  // if (cookie_box == undefined) {
  //   //console.log('cookie_box undefined');
  //   setTimeout(function () {
  //     $(".cookie-modal").removeClass("active");
  //   }, 3000);
  // } else 
  if (newletter_box == undefined) {
    //console.log('newletter_box undefined');
    setTimeout(function () {
      $(".newsletter-modal").removeClass("active");
    }, 3000);
  }

  // Close newsletter

  $(document).on("click", ".j-close-newsletter", function (e) {
    e.preventDefault();
    $(".newsletter-modal").addClass("active");
    Cookies.set("newletter_box", "true", { expires: 365 });
  });

  // Close cookie popup

  // $(document).on("click", ".j-close-cookie-popup", function (e) {
  //   e.preventDefault();
  //   // $(this).parent().addClass('active');
  //   $(this).closest(".cookie-modal").addClass("active");
  //   Cookies.set("cookie_box", "true", { expires: 365 });
  // });

  if ($(window).width() > 622) {
    var product_carousel_width = $(".j-mob-cp-carousel").width();
    var slides_to_show = product_carousel_width / 308;
  } else {
    var slides_to_show = 1;
  }

  $(".j-mob-cp-carousel").slick({
    infinite: false,
    slidesToShow: slides_to_show,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    dots: false,
    variableWidth: true,
    mobileFirst: true,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 639,
        settings: {
          arrows: true,
          slidesToShow: slides_to_show,
        },
      },
    ],
  });

  // Partner cards carousel

  // if ($(window).width() > 622) {

  // 	var j_partner_card_carousel_width = $('.j-mob-cp-carousel').width();
  // 	var j_partner_card_carousel_slides_to_show = j_partner_card_carousel_width / 308;
  // 	console.log(j_partner_card_carousel_slides_to_show);

  // } else {

  // 	var j_partner_card_carousel_slides_to_show = 1;

  // }

  $(".j-partner-card-carousel").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    dots: false,
    variableWidth: true,
    mobileFirst: true,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 639,
        settings: {
          arrows: true,
        },
      },
    ],
  });

  $(".j-partner-card-carousel").on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      $(".j-partner-card-carousel-title").matchHeight();
      console.log("REACHED");
    }
  );

  // Footer newsletter optin script

  $(document).on("click", "#consent-email", function () {
    $(".nl-wrapper").toggleClass("active");
  });

  $(".j-review-carousel").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
    dots: false,
    pauseOnHover: false,
    mobileFirst: true,
    asNavFor: ".j-dt-reviews",
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 639,
        settings: {
          variableWidth: true,
        },
      },
    ],
  });

  $(".j-dt-reviews").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    dots: false,
    fade: true,
    pauseOnHover: false,
    draggable: false,
    swipeToSlide: true,
  });

  if ($(window).width() < 1024) {
    $(".j-review-carousel").on(
      "afterChange",
      function (event, slick, currentSlide, nextSlide) {
        var publisher = $(".j-review-carousel .slick-active .publisher").text();
        $(".j-publisher-title").text(publisher);
      }
    );
  }

  $(document).on("click", ".j-toggle-variant", function (e) {
    e.preventDefault();
    $(this).parent().toggleClass("active");
    $(this).find("span").toggleText("+", "-");
  });

  $(".j-insta-feed").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
    dots: false,
    mobileFirst: true,
    appendArrows: $(".insta-arrows"),
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 639,
        settings: {
          slidesToScroll: 1,
          variableWidth: true,
        },
      },
    ],
  });

  $(document).on(
    "click mouseover",
    ".j-show-shopnav, .j-show-explore, .j-show-search",
    function (e) {
      e.preventDefault();
      $(".dt-menu li a").removeClass("active");
      $(this).addClass("active");

      // if ($(window).width() > 1024) {

      // 	header.addClass('menu-active');

      // }

      header.addClass("menu-active");

      $(".menu-list-explore, .menu-list-shop, .menu-list-search").hide();

      if ($(this).hasClass("j-show-shopnav")) {
        $(".menu-list-shop").show();
      } else if ($(this).hasClass("j-show-explore")) {
        $(".menu-list-explore").show();
      } else {
        $(".menu-list-search").show();
        $("#search").focus();
      }
    }
  );

  // $(document).scroll(function(){

  // 	if ( $('.dt-menu li a').hasClass('active') ){

  // 		setTimeout(function(){

  // 			$('.dt-menu li a').removeClass('active');
  // 			$('.menu-list-explore, .menu-list-shop, .menu-list-search').hide();

  // 			if ($(window).width() > 1024) {

  // 				header.removeClass('menu-active');

  // 			}

  // 		}, 500);

  // 	}

  // });

  // Toggle menu state

  $(document).on("click", ".j-show-benefit-menu", function (e) {
    e.preventDefault();
    $(this).addClass("active");
    $(".category-blocks").css("display", "none");
    $(".benefit-items").css("display", "flex");
    $(".j-shop-all-btn").hide();
    $(".j-menu-back-btn").show();
  });

  $(document).on("click", ".j-menu-back-btn a", function (e) {
    e.preventDefault();
    $(this).parent().hide();
    $(".j-shop-all-btn").show();
    $(".category-blocks").css("display", "flex");
    $(".benefit-items").css("display", "none");
    $(".j-show-benefit-menu").removeClass("active");
  });

  // Product page script

  $(".j-p-carousel").on('afterChange init', function(event, slick, currentSlide){
    slickVideoAutoplayHandler(slick);
  });
  $(".j-p-carousel").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    dots: false,
    fade: true,
    focusOnSelect: true,
  });

  // Product accordions
  $(document).on("click", ".j-product-accordion", function (e) {
    e.preventDefault();
    $(this)
      .parent()
      .parent()
      .toggleClass("active")
      .find("article")
      .slideToggle();

    if ($(this).hasClass("reintSlick")) {
      $(".j-nutritional-imgs").slick("reinit");
    }
  });

  // Related products / bundle creator

  $(document).on("click", ".wo-products .j-o-product", function (e) {
    e.preventDefault();
    $(this).toggleClass("active");

    var current_price = $(".j-item-totals").data("currentprice");
    console.log(current_price);

    var item_price = $(this).data("price");
    console.log("item price: " + item_price);

    if ($(this).hasClass("active")) {
      var total = current_price + item_price;
    } else {
      var total = current_price - item_price;
    }

    console.log("TOTAL:" + total);

    $(".j-item-totals").data("currentprice", total);
    console.log(total);

    $(".j-item-totals").text("£" + total.toFixed(2));

    if (total == 0) {
      $(".add-to-cart-optimise").addClass("disabled");
    } else {
      $(".add-to-cart-optimise").removeClass("disabled");
    }
  });

  // Update quantity on span click

  function quantitySelectorButtonClick(quantityInput, minus) {
    const oldValue = parseInt(quantityInput.value);
    let newValue; 
    if (minus) {
      newValue = oldValue - 1;
    } else {
      newValue = oldValue + 1;
    }
    if (newValue < 1) {
      newValue = 1;
    }
    quantityInput.value= newValue;
  }
  const quantitySelectors = Array.from(document.querySelectorAll('[data-product-quantity-selector]'));
  quantitySelectors.forEach(selector => {
    const input = selector.querySelector('input');
    const minusButton = selector.querySelector('.minus');
    const plusButton = selector.querySelector('.plus');

    minusButton.addEventListener('click', () => quantitySelectorButtonClick(input, true));
    plusButton.addEventListener('click', () => quantitySelectorButtonClick(input, false));
  })

  // Sidebar cart toggle

  $(document).on("click", ".j-toggle-cart", function (e) {
    e.preventDefault();
    //$('body').toggleClass('lock');
    $(this).toggleClass("active");
    $(".cart-sidebar").toggleClass("active");
    header.toggleClass("cart-active");

    $(".j-cupsell-item").matchHeight();

  });

  $(document).on("click", ".j-close-cart", function (e) {
    e.preventDefault();
    //$('body').removeClass('lock');
    $(".cart-sidebar").toggleClass("active");
    header.toggleClass("cart-active");
  });

  // Collection scripts

  // Toggle collection filters

  $(document).on("click", ".j-toggle-filter", function (e) {
    e.preventDefault();
    $(this).parent().toggleClass("active");
  });

  // Account page

  $(document).on("click", ".account-nav a", function (e) {
    if ($(this).attr("href") == "#") {
      e.preventDefault();
      $(this)
        .addClass("active")
        .parent()
        .siblings()
        .find("a")
        .removeClass("active");
      var active_item = $(this).data("account-menu");
      $(".a-section").removeClass("active");
      $(".a-section.data-" + active_item + "").addClass("active");

      var url = "?page=" + active_item + "";
      //document.location.hash = url;

      history.pushState("data", "", "/account" + url);
    }
  });

  // Toggle address form

  $(document).on("click", ".show_address_form", function (e) {
    e.preventDefault();
    var formID = $(this).data("form-id");
    console.log(formID);
    $("#EditAddress_" + formID + "").addClass("active");
  });

  $(document).on("click", ".j-close-address-form", function (e) {
    e.preventDefault();
    $(".edit-address-form").removeClass("active");
  });

  $(document).on("click", ".j-toggle-reset-password", function (e) {
    e.preventDefault();
    $("#login-form").hide();
    $("#reset-password-form").show();
  });

  $(document).on("click", ".j-toggle-login-form", function (e) {
    e.preventDefault();
    $("#reset-password-form").hide();
    $("#login-form").show();
  });

  // Accordion toggle (drug free page)

  $(document).on("click", ".j-accordion-toggle", function (e) {
    e.preventDefault();
    $(this).parent().toggleClass("active");
  });

  // Nutritional image carousel - product page

  $(".j-nutritional-imgs").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    dots: false,
  });

  // Filter toggle - collection page

  $(document).on("click", ".j-filter-toggle", function (e) {
    e.preventDefault();
    $(this).parent().toggleClass("active");
  });

  $(document).on("click", ".ajax-filter .j-filter-products", function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
    var filter = $(this).data("filter");
    var filter_title = $(this).data("filter-title");
    console.log(filter);
    console.log(filter_title);

    if ($(this).hasClass("active")) {
      var active_filters_list = $(".active-filters-list");
      active_filters_list.append(
        '<span class="j-remove-filter j-active-filter-' +
          filter +
          '">' +
          filter_title +
          "</span>"
      );
    } else {
      $(".j-active-filter-" + filter + "").remove();
    }

    // $('.product-item').hide();
    //$('.product-item.' + filter + '').show();

    $(".product-item").each(function () {
      $(this).removeClass("j-slick-filtered");

      if ($(this).hasClass(filter)) {
        $(this).css("opacity", 1).css("order", -1);
        $(this).addClass("j-slick-filtered");
      } else {
        $(this).css("opacity", 0.3);
        $(this).removeClass("j-slick-filtered");
      }
    });

    if ($(".ajax-filter .j-filter-products").hasClass("active")) {
      $(".reset-filter").show();
    } else {
      $(".reset-filter").hide();
      console.log("remove active state");
      $(".product-item").css("opacity", 1);
    }

    console.log("FILTER APPLIED");

    $(".collection-row").each(function () {
      var activeItems = $(this).find(".product-item.j-slick-filtered").length;

      if (!activeItems == 0) {
        $("html, body").animate({ scrollTop: $(this).offset().top - 0 }, 1000);
        return false;
      }
    });
  });

  $(document).on("click", ".j-remove-filter", function (e) {
    e.preventDefault();
    var removeThis = $(this)
      .attr("class")
      .replace("j-remove-filter j-active-filter-", "");
    console.log(removeThis);
    $('.j-filter-products[data-filter="' + removeThis + '"]').removeClass(
      "active"
    );
    $(this).remove();
  });

  $(document).on("click", ".j-reset-filters", function (e) {
    e.preventDefault();
    $(this).hide();
    $(".ajax-filter .j-filter-products").removeClass("active");
    $(".product-item").css("opacity", 1);
    $(".active-filters-list").html("");
  });

  // Athlete and club partnerships page

  $(document).on("click", ".j-toggle-athlete-block", function (e) {
    e.preventDefault();
    $(this).closest(".athlete-block").toggleClass("active");
  });

  // Style images on article page

  $(".j-article-imgs img").each(function () {
    if ($(this).attr("alt") == "half") {
      $(this).addClass("img-half");
      $(this).parent().addClass("p-remove");
    }

    if ($(this).attr("alt") == "full") {
      $(this).addClass("img-full");
      $(this).parent().addClass("p-remove");
    }
  });

  //Company number field toggle
  $(".radio-item").change(function () {
    if ($("#inc_entity_yes").is(":checked")) {
      $("#company-number").css("display", "block");
      $("#company-number").prop("required", true);
    } else {
      $("#company-number").css("display", "none");
    }
  });

  // toggle optin state (single and 2 checkboxes) on forms

  // $('.optin input[type="checkbox"]').change(function () {
  //   if ($('.optin').hasClass("opt-single")) {
  //     let checked = $(".optin-checkbox").filter(":checked").length !== 1;
  //     $(".j-optin-btn").prop("disabled", checked);
  //   } else {
  //     let checked = $(".optin-checkbox").filter(":checked").length !== 2;
  //     $(".j-optin-btn").prop("disabled", checked);
  //   }
  // });

  // toggle optin (dynamic count of checkboxes) on forms
  $('.optin input[type="checkbox"]').change(function () {
      // console.log($('.optin input[type="checkbox"]').length)
      let checked = $(".optin-checkbox").filter(":checked").length !== $(".optin-checkbox").length;
      $(".j-optin-btn").prop("disabled", checked);
    
  });

  // OLD toggle optin.
  // $(document).on('click', '.optin label', function(e){
  //   let checked = ($('.optin-checkbox').filter(':checked').length !== 2)
  //   console.log($('.optin-checkbox').filter(':checked').length)
  //   console.log(($('.optin-checkbox').filter(':checked').length === 2))
  //   // console.log("check1: " + $('#pt-optin').is(':checked'))
  //   // console.log("check2: " + $('#pt-optin-2').is(':checked'))
  //   $('.j-optin-btn').prop( "disabled", checked );
  // 	// if ($('#pt-optin').is(':checked') && $('#pt-optin-2').is(':checked') ) {
  // 	// 	$('.j-optin-btn').prop( "disabled", false );
  // 	// } else {
  // 	// 	$('.j-optin-btn').prop( "disabled", true );
  // 	// }

  // });

  // Guides page template

  $(document).on("click", ".j-scroll-to-guide", function (e) {
    e.preventDefault();

    var cat = $(this).data("cat");
    var section = $(".j-section-" + cat + "");
    console.log(cat);
    $("html, body").animate({ scrollTop: section.offset().top - 200 }, 1000);
  });

  $(document).on("click", ".j-disable-link a", function (e) {
    if (!$(this).hasClass("pdf-link")) {
      e.preventDefault();
    }
  });

  // FAQ page

  $(document).on("click", ".j-show-accordion", function () {
    console.log("clicked");
    //$('.accordion-block').removeClass('active');
    //$('.j-show-accordion').removeClass('active');
    $(this).toggleClass("active").next().toggleClass("active");
  });

  $(document).on("click", ".accordian_row .trigger", function (e) {
    e.preventDefault();
    $(this).parent().toggleClass("active").siblings().removeClass("active");
  });

  if ($(window).width() < 622) {
    $(window).scroll(function () {
      var innerHeight = window.innerHeight;
      console.log(innerHeight);
      //$('.innerhHeight').text(innerHeight);
      $(".site-header .menu-wrapper").height(innerHeight - 56);
    });
  }

  // Close nav on mouseleave

  if ($(window).width() > 622) {
    $(".menu-wrapper").mouseleave(function () {
      if ($(".site-header").hasClass("menu-active")) {
        console.log('you"ve left');
      }
    });
  }

  $("#dp").datepicker({
    changeMonth: true,
    changeYear: true,
    yearRange: "-100:+0",
  });

  function slickVideoAutoplayHandler(slick) {
    const currentSlideEl = slick.$slides.get(slick.slickCurrentSlide());
    console.log("CurrentSlideEl", currentSlideEl);
    setTimeout(() => {
      Array.from(slick.$slides).forEach((slide) => {
        const video = slide.querySelector("video");
        const isCurrentSlide = currentSlideEl === slide;
        if (!video) return;
        if (isCurrentSlide) {
          video.play();
        } else {
          video.pause();
        }
      });
    });
  }
});
